import { Component, OnInit, Input, TemplateRef, SimpleChanges, SimpleChange, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { OrderApiService } from '@core/http/order-api.service';
import { OrdersUtilService } from '@app/core/services/orders-util/orders-util.service';
import { DeviceService } from '@app/core/services/util/device.service';

import { FaqDialogComponent } from '@modules/faq/components/faq-dialog/faq-dialog.component';
import { lastValueFrom, Subject, takeUntil } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { NgClass, NgStyle, NgTemplateOutlet } from '@angular/common';
import { ToastrService } from '@app/core/services/notification/toastr.service';

@Component({
    selector: 'delivery-support',
    templateUrl: './delivery-support.component.html',
    styleUrls: ['./delivery-support.component.scss'],
    standalone: true,
    imports: [NgClass, NgStyle, NgTemplateOutlet, MatIconModule]
})

export class DeliverySupportComponent implements OnInit {

    @Input() order: any;
    @Input() wrapperClass: String;
    isMobile: boolean = false;
    showDeliveryConfirmation: boolean = false;
    HelpNSupportText: string;
    customer_support_details: any = {};
    destroySubject$: Subject<void> = new Subject();
    tracking_id: string;
    @ViewChild('contactTemplate') contactTemplate: TemplateRef<any>;

    constructor(
        private orderApiService: OrderApiService,
        private ordersUtil: OrdersUtilService,
        private dialog: MatDialog,
        private deviceService: DeviceService,
        private toastrService: ToastrService
    ) { 
    }

    ngOnInit(): void {
        this.customer_support_details = this.order.chat_support_details || {};
        this.tracking_id = this.order.order_details.tracking_id;

        this.ordersUtil.getDeliveryConfirmationStatus(this.order, this.order.delivery_confirmation.response);
        this.ordersUtil.deliveryInfoObserver
        .pipe(takeUntil(this.destroySubject$))
        .subscribe((data: any) => {
            this.showDeliveryConfirmation = data.showDeliveryConfirmation;
            this.HelpNSupportText = data.HelpNSupportText;
        });

        this.isMobile = this.deviceService.isMobile();
    }

    ngOnChanges(changes: SimpleChanges) {
        const change: SimpleChange = changes.order;
        if (change) {
            this.ordersUtil.getDeliveryConfirmationStatus(this.order, this.order.delivery_confirmation.response);
        }
    }

    ngOnDestroy() {
        this.destroySubject$.next();
        this.destroySubject$.complete();
    }

    openFaqDialog() {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.panelClass = "faqs-dialog";
        dialogConfig.data = {
          heading: `Order #${this.tracking_id}`,
          tracking_id: this.tracking_id,
          status: this.order.currentStatus
        };
        dialogConfig.autoFocus = false;
        this.dialog.open(FaqDialogComponent, dialogConfig);
    }

    setDeliveryConfirmationStatus(value: boolean) {
        lastValueFrom(this.orderApiService.submitDeliveryConfirmationResponse(this.tracking_id, value))
            .then((response: any) => {
                if (response.report?.customer_confirmation) {
                    this.ordersUtil.getDeliveryConfirmationStatus(this.order, value);
                } else {
                    this.toastrService.openSnackBar(response.meta.message, 'OKAY!')
                }
            }).catch((error) => {
                this.toastrService.openSnackBar(error?.meta?.message, 'OKAY!')
            });
    }

    getSupport(type, contact) {
        switch (type) {
            case 'chat':
                this.openFaqDialog();
                break;
            default:
                if(this.isMobile) {
                    window.location.href = `tel:${contact}`;
                } else {
                    this.openDialog(this.contactTemplate, {type, contact});
                }
                break;
        }
    }

    openDialog(templateRef: TemplateRef<any>, data) {
        if(templateRef) {
            this.dialog.open(templateRef, {
                panelClass: 'floating-panel',
                minWidth: '350px',
                data
            });
        }
    }

    close() {
        this.dialog.closeAll();
    }
}
